import React from 'react';
import { Link } from 'react-router-dom';
import { Target } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-slate-50 border-t border-slate-200 py-6 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Copyright */}
          <div className="flex items-center gap-2 text-sm text-slate-600">
            <Target className="w-4 h-4 text-primary" />
            <span>© {currentYear} Archery Manager AI. All rights reserved.</span>
          </div>
          
          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/about" 
              className="text-slate-600 hover:text-primary transition-colors"
              data-testid="footer-about-link"
            >
              About the Builder
            </Link>
            <Link 
              to="/terms" 
              className="text-slate-600 hover:text-primary transition-colors"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </Link>
            <Link 
              to="/privacy" 
              className="text-slate-600 hover:text-primary transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
        
        {/* Description */}
        <p className="mt-3 text-xs text-slate-500 max-w-2xl">
          Archery Manager AI is a proprietary platform for archery event tracking, performance insights, and analytics.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
